import { useState } from 'react'
import { EditButton } from '../EditButton'
import { ClientAdditionalInfoPopup } from '../Popups/ClientAdditionalInfoPopup'
import { IClient, IClientCreate} from 'src/utils/Interfaces/client.interface'
import { useUpdateClientMutation } from 'src/redux/Api/clientsApi'

export const EditClientAdditionalInfo = ({ data }: { data: IClient}) => {
  const [isEdit, setIsEdit] = useState(false)
  const [updateClient] = useUpdateClientMutation()
  const { id, ...restData } = data;

  const handleClientMainInfo = async (value: Partial<IClientCreate>) => {
    try {
      await updateClient({ id: data.id.toString(), body: {...restData, ...value} })
      setIsEdit(false)
    } catch (error) {
      console.log(error)
    }
  }
  
  return (
    <>
      <EditButton onClick={() => setIsEdit(true)} />
      {isEdit && <ClientAdditionalInfoPopup defaultData={data} handleClientAdditionalInfo={handleClientMainInfo} setClientAdditionalInfoPopup={() => setIsEdit(false)} />}
    </>
  )
}
